import { CurrencyEnum } from '__generated__/types';
import { ENV_APP_REGION } from 'constants/env';

import { EURegionConfig } from './configs/eu';
import { SGRegionConfig } from './configs/sg';
import { TRRegionConfig } from './configs/tr';
import { UKRegionConfig } from './configs/uk';
import { AccountingIdCommentNames, AccountingIdNames, AccountingIds, Regions, RegionsData } from './types';

export const RegionsConfig: RegionsData = {
  [Regions.EU]: EURegionConfig,
  [Regions.TR]: TRRegionConfig,
  [Regions.UK]: UKRegionConfig,
  [Regions.SG]: SGRegionConfig,
};

export const CURRENT_REGION = RegionsConfig[ENV_APP_REGION as keyof typeof RegionsConfig]?.region;
export const CURRENCIES = Object.values(CurrencyEnum);

export const ACCOUNTING_ID_KEY: Record<Regions, AccountingIds> = {
  [Regions.EU]: AccountingIds.datevId,
  [Regions.TR]: AccountingIds.intacctId,
  [Regions.UK]: AccountingIds.intacctId,
  [Regions.SG]: AccountingIds.intacctId, // TODO: SG
};

export const ACCOUNTING_ID_NAME: Record<Regions, AccountingIdNames> = {
  [Regions.EU]: AccountingIdNames.DATEV,
  [Regions.TR]: AccountingIdNames.INTACCT,
  [Regions.UK]: AccountingIdNames.INTACCT,
  [Regions.SG]: AccountingIdNames.INTACCT, // TODO: SG
};

export const ACCOUNTING_ID_COMMENT_NAME: Record<Regions, AccountingIdCommentNames> = {
  [Regions.EU]: AccountingIdCommentNames.datevComment,
  [Regions.TR]: AccountingIdCommentNames.intacctComment,
  [Regions.UK]: AccountingIdCommentNames.intacctComment,
  [Regions.SG]: AccountingIdCommentNames.intacctComment, // TODO: SG
};
